import axios from 'axios'

// POST Create new house
export const addHouse = house => {
    return new Promise(((resolve, reject) => {
        axios.post('house/create', house)
            .then(response => {
                resolve(response.data)
            })
            .catch(error => reject(error))
    }))
}

// PUT Edid house entity
export const updateHouse = (houseId, house) => {
    return new Promise(((resolve, reject) => {
        axios.put(`/house/update/${houseId}`, house)
            .then(response => {
                resolve(response.data)
            })
            .catch(error => reject(error))
    }))
}

// GET Retrieve all houses
export const getAllHouses = (token) => {
    return new Promise((resolve, reject) => {
        axios.get('user/getallhouses', {
            headers: {
                Authorization: `${token}`
            }
        })
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error);
            });
    });
};


// GET specific house by ID
export const getHouseEntity = houseId => {
    return new Promise(((resolve, reject) => {
        axios.get(`house/get/${houseId}`)
            .then(response => {
                resolve(response.data)
            })
            .catch(error => reject(error))
    }))
}

// DELETE house entity
export const deleteHouseEntity = houseId => {
    return new Promise(((resolve, reject) => {
        axios.delete(`house/delete/${houseId}`)
            .then(response => {
                resolve(response.data)
            })
            .catch(error => reject(error))
    }))
}

// GET house periodic consumptions
export const getHousePeriodicConsumptions = (period, houseId) => {
    return new Promise((resolve, reject) => {
        axios.get(`/data/${period}/${houseId}`)
            .then(response => {
                resolve(response.data)
            })
            .catch(error => reject(error))
    })
}

// GET house today 5min consumption
export const getHouseTodayConsumption = houseId => {
    return new Promise((resolve, reject) => {
        axios.get(`/data/lastday/${houseId}`)
            .then(response => {

                if (response.data.consumption === null || response.data.labels === null) reject('Not available data.')
                else resolve(response.data)
            })
            .catch(error => reject(error))
    })
}

// GET house last hour consumption
export const getHouseLastHourConsumption = houseId => {
    return new Promise((resolve, reject) => {
        axios.get(`/data/lasthour/${houseId}`)
            .then(response => {
                if (response.data.consumption === null || response.data.labels === null) reject('Not available data.')
                else resolve(response.data)
            })
            .catch(error => reject(error))
    })
}

// GET house billing info
export const getHouseBillingInfo = houseId => {
    return new Promise((resolve, reject) => {
        axios.get(`/data/cost/currentmonth/${houseId}`)
            .then(response => {
                resolve(response.data)
            })
            .catch(error => reject(error))
    })
}

// GET house billing info
export const getHouseCostHistory = houseId => {
    return new Promise((resolve, reject) => {
        axios.get(`/data/cost/history/${houseId}`)
            .then(response => {
                resolve(response.data)
            })
            .catch(error => reject(error))
    })
}

// GET house latest metrics
export const getHouseLatestMetrics = houseId => {
    return new Promise((resolve, reject) => {
        axios.get(`/data/metrics/${houseId}`)
            .then(response => {
                resolve(response.data)
            })
            .catch(error => reject(error))
    })
}


// GET house insights
export const getHouseInsights = houseId => {
    return new Promise((resolve, reject) => {
        axios.get(`/data/insights/${houseId}`)
            .then(response => {
                resolve(response.data)
            })
            .catch(error => reject(error))
    })
}